<template>
  <Blog />
</template>

<script>
import Blog from '@/components/pages/Blog/Blog.vue';
import blogPageMixin from '@/components/mixins/blogPageMixin';
import AppConstantsUtil from '@/services/utils/AppConstantsUtil';

function getHeadInfo(store) {
  return store.dispatch('BlogStore/getBlogArticlesListPageHeadInfo');
}

export default {
  name: 'BlogPage',
  components: {
    Blog
  },
  mixins: [blogPageMixin],
  async asyncData({ store }) {
    const { meta, link, title } = await getHeadInfo(store);
    await Promise.all([
      store.dispatch('BlogStore/searchArticlesTags'),
      store.dispatch('BlogStore/searchArticles', {})
    ]);
    return { meta, link, title };
  },
  head() {
    return {
      meta: this.meta,
      title: this.title,
      link: this.link,
      htmlAttrs: {
        class: [
          ...this.htmlClassList,
          AppConstantsUtil.MANAGE_PUBLICATION_SCROLL_CLASS
        ]
      }
    };
  }
};
</script>

<style></style>
